module.exports = __webpack_public_path__ + "static/media/Item_Armor_D_00_Lv2_C.94a385c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/item/Equipment/Vest/Item_Armor_D_00_Lv2_C.png
// module id = 372
// module chunks = 0